import { styled } from "@mui/material/styles";

// Since we're moving to the sx prop, we don't need makeStyles
// We'll convert these styles to be used directly with sx prop
const formControlSx = (theme) => ({
  margin: theme.spacing(1),
  width: 300,
});

const indeterminateColor = "#f50057";

const selectAllText = {
  fontWeight: 500,
};

const selectedAllSx = {
  backgroundColor: "rgba(0, 0, 0, 0.08)",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
  },
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

const options = [
  "Software Developer",
  "Full-stack Developer",
  "Front-end Developer",
  "Back-end Developer",
  "Business Analyst",
  "UX / UI Designer",
  "Software Tester / QA Engineer",
  "QA Lead / Test Manager",
  "Project Manager",
  "Enterprise Architect",
  "Software Architect",
  "Scrum Master",
  "Team Lead / Tech Lead",
  "Other",
];

export {
  formControlSx,
  indeterminateColor,
  selectAllText,
  selectedAllSx,
  MenuProps,
  options,
};